"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameScene = void 0;
const KHRandom_1 = require("./KH/KHRandom");
const CTGCardView_1 = require("./Display/CTGCardView");
const CTGArrow_1 = require("./Display/CTGArrow");
const CTGGameMode_1 = require("./GameModes/CTGGameMode");
const CTGGameModes_1 = require("./CTGGameModes");
const CTGPercentBar_1 = require("./Display/CTGPercentBar");
const phaser3_ninepatch_1 = require("@koreez/phaser3-ninepatch");
const CTGOptionArrow_1 = require("./Display/CTGOptionArrow");
const CTGHighScores_1 = require("./CTGHighScores");
const CTG_1 = require("./CTG");
const CTGGameModeEndless_1 = require("./GameModes/CTGGameModeEndless");
var GameDepth;
(function (GameDepth) {
    GameDepth[GameDepth["BG"] = 0] = "BG";
    GameDepth[GameDepth["Card"] = 1] = "Card";
    GameDepth[GameDepth["TopCard"] = 2] = "TopCard";
    GameDepth[GameDepth["Shield"] = 3] = "Shield";
    GameDepth[GameDepth["Frame"] = 4] = "Frame";
    GameDepth[GameDepth["Bars"] = 5] = "Bars";
    GameDepth[GameDepth["Popup"] = 6] = "Popup";
})(GameDepth || (GameDepth = {}));
class CTGGameScene extends Phaser.Scene {
    constructor() {
        super("CTGGameScene");
    }
    init(data) {
        this.rand = new KHRandom_1.KHRandomGeneral();
        this.initial_level = data.initial_level === undefined ? 0 : data.initial_level;
        this.current_level = data.level === undefined ? this.initial_level : data.level;
        this.difficulty = this.current_level / 10 + 0.1;
        this.game_modes = data.game_modes === undefined ? CTGGameModes_1.game_modes : data.game_modes;
        this.config = this.rand.getRandom(this.game_modes);
        console.log(this.current_level);
    }
    create() {
        this.dither_fade = [];
        for (let i = 0; i < 17; i++) {
            let obj = new Phaser.GameObjects.TileSprite(this, 0, 0, 64, 64, 'ditheranim', 'd' + i).setOrigin(0);
            this.dither_fade.push(new Phaser.Display.Masks.BitmapMask(this, obj));
        }
        this.shield = this.add.sprite(0, -64, 'grate').setOrigin(0).setInteractive().setDepth(GameDepth.Shield);
        this.audio_scene = CTG_1.game_manager.add_or_get_audio_scene(this);
        if (!(this.config.game_mode instanceof CTGGameModeEndless_1.CTGGameModeEndless)) {
            this.audio_scene.fade_out(1000);
        }
        this._card_views = [];
        this.win_sound = this.sound.add("win");
        this.win_sound.volume = 1.5;
        this.game_width = Number(this.game.config.width);
        this.game_height = Number(this.game.config.height);
        this._sound_set = new Set();
        this._allow_clicks = false;
        this.add.tileSprite(0, 0, this.game_width, this.game_height, 'dither').setTint(0x037c2c).setOrigin(0).setDepth(GameDepth.BG);
        this.add.sprite(0, 0, 'frame').setOrigin(0).setDepth(GameDepth.Frame);
        // Old time_color: 0xac3232
        this.time_bar = new CTGPercentBar_1.CTGPercentBar(this, 1, 56, 0x0, this.config.game_mode.win_on_time_out ? 0x03772a : 0xebed3f).setPosition(62, 6).setDepth(GameDepth.Bars);
        this.add.existing(this.time_bar);
        this.score_bar = new CTGPercentBar_1.CTGPercentBar(this, 1, 56, 0x0, 0x03772a).setPosition(60, 6).setDepth(GameDepth.Bars);
        this.score_bar.set_percent(0);
        this.score_bar.setVisible(!this.config.game_mode.win_on_time_out);
        if (this.config.game_mode.win_on_time_out) {
            this.time_bar.x = 61;
        }
        this.add.existing(this.score_bar);
        if (this.config.game_mode.show_close) {
            let close = this.add.sprite(61, 2, 'close').setDepth(GameDepth.Bars).setInteractive();
            close.on('pointerdown', (pointer) => {
                this.config.game_mode.game_ended();
                this.config.game_mode.unregisterAllCallbacks();
                this.scene.start('CTGMainMenuScene');
            });
        }
        this.input.on("pointerdown", (pointer) => {
            if (this._allow_clicks)
                this.config.game_mode.clicked(this, pointer.x, pointer.y);
        });
        this.start_game();
    }
    save_key() {
        return this.game_modes.length == 1 ? this.game_modes[0].title : "Panic";
    }
    animate_lose(new_high_score) {
        let popup_width = 40;
        let popup_height = 25;
        let lose_popup = new phaser3_ninepatch_1.NinePatch(this, 32, -32, popup_width, popup_height, 'popup', null, {
            top: 2, bottom: 2, left: 2, right: 2
        }).setDepth(GameDepth.Popup);
        this.add.existing(lose_popup);
        let sx = -popup_width / 2 + 2;
        let sy = -popup_height / 2 + 2;
        let text = this.add.bitmapText(sx, sy, 'font', "GAME OVER", 6).setTint(0x0);
        lose_popup.add(text);
        text = this.add.bitmapText(sx, sy + 8, 'font', "SCORE:", 6).setTint(0x0);
        lose_popup.add(text);
        text = this.add.bitmapText(sx + popup_width - 3, sy + 8, 'font', "" + this.current_level, 6).setOrigin(1, 0).setTint(new_high_score ? 0x037c2c : 0xac3232);
        lose_popup.add(text);
        text = this.add.bitmapText(sx, sy + 15, 'font', "HIGH:", 6).setTint(0x0);
        lose_popup.add(text);
        text = this.add.bitmapText(sx + popup_width - 3, sy + 15, 'font', "" + CTGHighScores_1.HighScores.get_best_score(this.save_key()), 6).setOrigin(1, 0).setTint(new_high_score ? 0x037c2c : 0xac3232);
        lose_popup.add(text);
        const pop_y = 28;
        const option1 = new CTGOptionArrow_1.CTGOptionArrow(this, "RETRY", 18, false, () => option1.animate_select(), () => option1.animate_deselect(), () => {
            this.scene.start(this.scene.key, { game_modes: this.game_modes, initial_level: this.initial_level });
        }, null).setX(-64).setY(pop_y + popup_height / 2 + 2);
        this.add.existing(option1);
        const option2 = new CTGOptionArrow_1.CTGOptionArrow(this, "MENU", 18, false, () => option2.animate_select(), () => option2.animate_deselect(), () => {
            this.scene.start('CTGMainMenuScene');
        }, null).setX(-64).setY(pop_y + popup_height / 2 + 11);
        this.add.existing(option2);
        this.tweens.add({
            targets: lose_popup,
            y: 28,
            ease: 'Bounce.easeOut',
            duration: 1000,
        });
        this.tweens.add({
            targets: [option1, option2],
            x: 0,
            ease: 'Bounce.easeOut',
            duration: 1000,
            onComplete: () => {
                option1.set_selectable(true);
                option2.set_selectable(true);
            }
        });
    }
    update(now, delta) {
        this.config.game_mode.update(this, now, delta, this.difficulty, this.input.x, this.input.y, this.input.activePointer.isDown);
        this.play_queued_sounds();
    }
    add_sound_to_set(sound) {
        this._sound_set.add(sound);
    }
    play_queued_sounds() {
        if (this._sound_set.has('sfx_destroy'))
            this.sound.play('sfx_destroy');
        else if (this._sound_set.has('sfx_cancel'))
            this.sound.play('sfx_cancel');
        else if (this._sound_set.has('sfx_select'))
            this.sound.play('sfx_select');
        this._sound_set.clear();
    }
    create_cards(cards) {
        const card_views = [];
        cards.forEach(card => {
            const card_view = new CTGCardView_1.CTGCardView(this, card, this.dither_fade);
            this.add.existing(card_view);
            card_views.push(card_view);
            this._card_views.push(card_view);
        });
        return card_views;
    }
    handle_level_over() {
        this.config.game_mode.unregisterAllCallbacks();
        this.audio_scene.fade_out(1000);
        this._allow_clicks = false;
    }
    card_views_from_cards(cards) {
        if (cards == null || cards.length == 0)
            return [];
        return this._card_views.filter(cv => cards.includes(cv.card));
    }
    flip_all_cards(duration, callback) {
        let need_to_flip = false;
        for (let card of this._card_views) {
            if (!card.showing_front) {
                // Only trigger callback on first card to flip.
                card.maybe_flip_card(true, duration, 0, !need_to_flip ? callback : undefined);
                need_to_flip = true;
            }
        }
        ;
        if (!need_to_flip) {
            if (callback)
                callback();
        }
    }
    animate_problem_cards_onscreen(duration, cards, callback) {
        let need_to_animate = false;
        for (let card of cards) {
            if (card.needs_to_animate_onscreen(CTG_1.game_bounds)) {
                // Only trigger callback on first card to flip.
                card.animate_onscreen(duration, CTG_1.game_bounds, !need_to_animate ? callback : undefined);
                card.setDepth(GameDepth.Frame);
                need_to_animate = true;
            }
        }
        if (!need_to_animate) {
            if (callback)
                callback();
        }
    }
    blink_cards(duration, times, cards, callback) {
        if (cards == null || cards.length == 0) {
            if (callback)
                callback();
            return;
        }
        let first = true;
        for (let card of cards) {
            card.blink(duration, times, first ? callback : undefined);
            first = false;
        }
    }
    play_new_song() {
        const songs = [
            ['song1', 0.5],
            ['song2', 0.5],
            ['song3', 0.5],
            ['song4', 0.5],
            ['song5', 0.5],
            ['song6', 0.5],
            ['song7', 1],
            ['song8', 1],
            ['song9', 1],
            ['song10', 1],
        ];
        let song = this.rand.getRandom(songs);
        if (this.config.game_mode instanceof CTGGameModeEndless_1.CTGGameModeEndless) {
            this.audio_scene.play('main_menu', true, true, 0.5);
        }
        else {
            this.audio_scene.play(song[0], true, false, song[1], true);
        }
    }
    start_game() {
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_INITIAL_CARDS, ({ cards: cards }) => {
            let anim = this.rand.getRandom(this.config.game_mode.supported_animations());
            let card_views = this.create_cards(cards);
            anim.animate_in(this, card_views, () => {
                this.play_new_song();
                this.config.game_mode.did_start(this);
            });
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_GAME_STARTED, () => {
            this._allow_clicks = true;
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_ADD_CARDS, ({ cards: cards }) => {
            this.create_cards(cards);
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_CARD_DESTROYED, ({ card: card }) => {
            this._card_views = this._card_views.filter((x) => x != card);
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_WON, () => {
            this.handle_level_over();
            this.win_sound.play();
            this.config.game_mode.on_end();
            this.congrats_arrow.animate_in_no_dropdown(1600, () => {
                this.scene.start(this.scene.key, { difficulty: this.difficulty + 0.1, game_modes: this.game_modes, level: this.current_level + 1, initial_level: this.initial_level });
            });
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_LOST, ({ cards: cards }) => {
            this.handle_level_over();
            let score = new CTGHighScores_1.CTGScore(this.current_level);
            let new_best = CTGHighScores_1.HighScores.is_new_best(this.save_key(), score, false);
            CTGHighScores_1.HighScores.add_high_score(this.save_key(), score, false);
            this.sound.play('lose');
            let card_views = this.card_views_from_cards(cards);
            this.flip_all_cards(500, () => {
                this.animate_problem_cards_onscreen(300, card_views, () => {
                    this.blink_cards(2000, 3, card_views, () => {
                        this.config.game_mode.on_end();
                        this.animate_lose(new_best);
                    });
                });
            });
            // this.scene.start(this.scene.key, { difficulty: this.difficulty - 0.1, game_modes: this.game_modes });
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_SCORE_UPDATE, ({ score: new_value, percent: percent }) => {
            this.score_bar.set_percent(percent);
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_TIME_UPDATE, ({ time: new_value, delta: delta, time_left: time_left, percent: percent }) => {
            if (time_left < 1000 && delta + time_left >= 1000) {
                this.sound.play('sfx_clock1');
            }
            else if (time_left < 2000 && delta + time_left >= 2000) {
                this.sound.play('sfx_clock2');
            }
            else if (time_left < 3000 && delta + time_left >= 3000) {
                this.sound.play('sfx_clock1');
            }
            this.time_bar.set_percent(percent, true);
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_SHOW_SHIELD, () => {
            this.shield.y = -64;
            this.tweens.add({
                targets: this.shield,
                y: -1 - this.config.game_mode.spacing(),
                ease: 'Bounce.easeOut',
                duration: 500,
            });
        });
        this.config.game_mode.registerCallback(CTGGameMode_1.CTGGameMode.EVENT_HIDE_SHIELD, () => {
            this.shield.y = -1 - this.config.game_mode.spacing();
            this.tweens.add({
                targets: this.shield,
                y: -64,
                ease: 'Quad.easeIn',
                duration: 500,
            });
        });
        const congrats_messages = [
            "Nice Job!",
            "Excellent!",
            "Keep It Up!",
            "Great Job!",
            "Go! Go! Go!",
            "You've Got This.",
            "Radicool!",
            "Bodacious.",
        ];
        this.congrats_arrow = new CTGArrow_1.CTGArrow(this, this.rand.getRandom(congrats_messages), "").setDepth(GameDepth.Popup).setX(-64);
        this.add.existing(this.congrats_arrow);
        this.congrats_arrow.y = Math.floor((this.game_height - 8) / 2);
        this.arrow = new CTGArrow_1.CTGArrow(this, this.config.title, this.config.description).setDepth(GameDepth.Popup);
        this.add.existing(this.arrow);
        this.arrow.y = Math.floor((this.game_height - this.arrow.full_height()) / 2);
        this.arrow.animate_in(() => {
            this.arrow.setVisible(false);
            this.config.game_mode.start(this, this.rand, this.difficulty);
        });
    }
}
exports.CTGGameScene = CTGGameScene;
